import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';
import { Note } from 'shiftNotes/_types';

type ResolveNoteEventId = (noteId: string) => Promise<string | null>;

export default function useResolveNoteEventId(): ResolveNoteEventId {
  const queryClient = useQueryClient();

  return useCallback(
    async (noteId: string) => {
      try {
        const note = await queryClient.fetchQuery<Note>({
          queryKey: [APIKey.SHIFT_NOTE, noteId],
          queryFn: () => baseFetcher(apiRoutes.shiftNote(noteId)),
        });
        return note?.event ?? null;
      } catch {
        return null;
      }
    },
    [queryClient]
  );
}
